<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="500px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <!-- v-on="on" -->
      <v-btn small v-bind="attrs" v-on="on" icon>
        <v-icon small>fas fa-pen</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar color="teal darken-3 white--text" dense class="mb-3">
        <v-toolbar-title>
          {{ inventory.code }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="dialog = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <h1>Hellow</h1> -->
      <v-card-text>
        <v-form v-model="valid" ref="EnvEditeForm" class="py-3">
          <v-text-field
            outlined
            filled
            readonly
            label="Item Name"
            v-model="inventory.InvName"
            :rules="ItemNameRule"
            required
          ></v-text-field>

          <BaseNumInput
            outlined
            filled
            readonly
            :label="inventory.UnitType + ' COST'"
            :rules="QtyRule"
            v-model.number="inventory.cost"
          ></BaseNumInput>

          <BaseNumInput
            outlined
            :label="inventory.UnitType + ' PRICE'"
            v-model.number="inventory.price"
          ></BaseNumInput>

          <v-toolbar dense class="elevation-0">
            {{ profit }}
            <v-spacer></v-spacer>
            <v-btn :disabled="isloading" class="mr-3 error" @click="Cancel"
              >Cancel</v-btn
            >

            <v-btn :loading="isloading" @click="OnEdite" :disabled="!valid">
              submit
            </v-btn>
          </v-toolbar>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <p v-if="ErrMsg" class="error--text">{{ ErrMsg }}</p>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    EditeItems: { type: Object, required: true },
    OnFinish: { type: Function, required: true },
  },

  data() {
    return {
      ErrMsg: "",
      dialog: false,
      isloading: false,
      valid: true,
      inventory: {},
      UnitQty: 0,
      QtyItems: 0,
      ItemNameRule: [v => !!v || "Item Name is required"],
      QtyRule: [
        v => !!v || "Qty is required",
        v => {
          if (v && !isNaN(v.replace(/,/g, "")))
            this.QtyItems = parseInt(v.replace(/,/g, ""));
          return (v && v.replace(/,/g, "")) >= 0 || `QTY ${v} is not allowed`;
        },
      ],
      PriceRule: [v => !!v || "Price is required"],
      Stock: "/stock/editeprice",
    };
  },
  computed: {
    profit() {
      let { cost, price } = this.inventory;
      let prfit = parseFloat((price / cost - 1) * 100).toFixed(1);
      return prfit;
    },
  },
  watch: {
    dialog(v) {
      if (v) {
        this.inventory = { ...this.EditeItems };
        this.ErrMsg = "";
        // console.log(this.EditeItems);
      }
    },
  },
  methods: {
    OnEdite() {
      this.ErrMsg = "";
      if (this.$refs.EnvEditeForm.validate()) {
        this.isloading = true;
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: this.Stock,
            data: this.inventory,
          })
          .then(result => {
            this.OnFinish(result.data, true);
            this.Cancel();
            // this.isloading = false;
          })
          .catch(err => {
            this.ErrMsg = err && err.response && err.response.data;
            console.log(err);
          })
          .finally(() => {
            this.isloading = false;
            // console.log("Final");
          });
      }
    },
    Cancel() {
      // this.$refs.EnvEditeForm.reset();
      this.inventory = {};
      this.UnitQty = 0;
      this.dialog = false;
    },
  },
};
</script>
